// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBgDbZK1BuMsOTC_wW6LKHlD4e6t36dCSI",
  authDomain: "my-website-aa119.firebaseapp.com",
  projectId: "my-website-aa119",
  storageBucket: "my-website-aa119.firebasestorage.app",
  messagingSenderId: "793123051215",
  appId: "1:793123051215:web:6206f1df3a45e3143c89ba",
  measurementId: "G-ZMG69N4MSH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

// Export the Firebase instances
export { app, analytics, db };